module.exports = __webpack_public_path__ + "media/images/icon-close-search-alternate-e4fa4155cb35b47d60e85e800b3f590d.svg";